/**
 * Notification sound synthesized with the Web Audio API -- no external audio file (no new
 * dependency, no licensing concern). A short chime of 2 ascending tones.
 */

let sharedContext: AudioContext | null = null;

const getContext = (): AudioContext | null => {
  if (typeof window === 'undefined') return null;
  const Ctor = window.AudioContext || (window as any).webkitAudioContext;
  if (!Ctor) return null;
  if (!sharedContext) sharedContext = new Ctor();
  return sharedContext;
};

const playTone = (ctx: AudioContext, frequency: number, startTime: number, duration: number) => {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = 'sine';
  oscillator.frequency.value = frequency;
  gain.gain.setValueAtTime(0, startTime);
  gain.gain.linearRampToValueAtTime(0.2, startTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(startTime);
  oscillator.stop(startTime + duration);
};

/** Plays the notification chime. Silent if the browser doesn't support Web Audio or if the
 * AudioContext is still suspended (some browsers require it after a user interaction). */
export const playNotificationSound = (): void => {
  const ctx = getContext();
  if (!ctx) return;
  if (ctx.state === 'suspended') { ctx.resume().catch(() => {}); }
  const now = ctx.currentTime;
  playTone(ctx, 880, now, 0.15);
  playTone(ctx, 1318.5, now + 0.1, 0.2);
};
